import { FaxFormData, FormFieldConfig } from "../types";

/**
 * Transforms form data to Firebase-compatible structure using firebaseKey mappings
 * @param formData - The form data from the questionnaire
 * @param formConfig - The form configuration with firebaseKey mappings
 * @returns Nested object structure for Firebase update
 */
export const transformFormDataToFirebase = (
  formData: FaxFormData,
  formConfig: FormFieldConfig[],
): Record<string, any> => {
  const firebaseData: Record<string, any> = {};

  // Iterate through all sections and fields
  formConfig.forEach((section) => {
    section.fields.forEach((field) => {
      if (field.firebaseKey && formData[field.name as keyof FaxFormData]) {
        const value = formData[field.name as keyof FaxFormData];

        // Skip empty values
        if (value === "" || value === null || value === undefined) {
          return;
        }

        // Split the firebaseKey path and create nested structure
        const keyParts = field.firebaseKey.split(".");
        let current = firebaseData;

        // Create nested structure
        for (let i = 0; i < keyParts.length - 1; i++) {
          const part = keyParts[i];
          if (!current[part]) {
            current[part] = {};
          }
          current = current[part];
        }

        // Set the final value
        const finalKey = keyParts[keyParts.length - 1];
        current[finalKey] = value;
      }
    });
  });

  return firebaseData;
};
